// extracted by mini-css-extract-plugin
var _1 = "MainNavigation_container__+9b7s";
var _2 = "MainNavigation_divider__SoEkG";
var _3 = "MainNavigation_language__ZArt-";
var _4 = "MainNavigation_logout__EMtDr";
var _5 = "MainNavigation_mobile__e3S7C";
var _6 = "MainNavigation_noPointerEvents__4dC+a";
var _7 = "MainNavigation_profile__3Rt28";
export { _1 as "container", _2 as "divider", _3 as "language", _4 as "logout", _5 as "mobile", _6 as "noPointerEvents", _7 as "profile" }
